<template>
  <button-hover></button-hover>
</template>

<script>
import buttonHover from "./ButtonHoverModule";

export default {
  components: {
    buttonHover,
  },
  created() {
    let docClasses = document.body.classList;
    docClasses.remove("white-content");
  },
};
</script>

<style scoped>
</style>
